import { InputAdornment } from "@mui/material";
import React, { useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { ButtonGroup, Input } from "../../../controls";
import { DropLi } from "../../../hooks";
import { CartContext } from "../Pos";

const AdditionalDiscount = ({ values, setValues, handleInpChg, totalPay }) => {
  const { t } = useTranslation();
  const { DiscountTypes } = DropLi();
  const { editSale, quote } = useContext(CartContext);

  // Quote or Edit Sale Discount
  useEffect(() => {
    setTimeout(() => {
      if (editSale && editSale.id) {
        setValues((j) => ({
          ...j,
          id: editSale.id || "",
          discount: editSale.discount || "",
          discountType: editSale.discountType || 1,
          disAmt: editSale.disAmt || "",
          quoteSaleId: editSale.quoteSaleId || "",
        }));
      } else if (quote && quote.id) {
        setValues((j) => ({
          ...j,
          quoteSaleId: quote.id || "",
          disAmt: quote.disAmt || "",
          discount: quote.discount || "",
          discountType: quote.discountType || 1,
          note: quote.note || "",
        }));
      }
    }, 1000);

    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editSale, quote]);

  const handleDisType = (val) => {
    setValues((x) => ({ ...x, discountType: val, discount: "" }));
  };

  const handleChange = (e) => {
    var val = parseFloat(e.target.value);
    if (
      val <= totalPay ||
      values.discount.length > e.target.value.length ||
      (values.discountType === 1 && val <= 100)
    )
      handleInpChg(e);
  };

  return (
    <>
      <span className="fs-12 fw-5 tx-upp gray-color pl-10">
        {t("additionalDiscount")}
      </span>

      <Input
        fullWidth
        placeholder="0.000"
        name="discount"
        value={values.discount}
        onInput={(e) => (e.target.value > 0 ? e : (e.target.value = ""))}
        onChange={handleChange}
        className="rmv-arrow"
        variant="outlined"
        size="small"
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <ButtonGroup
                activeVal={values.discountType || 0}
                onChange={handleDisType}
                list={DiscountTypes}
                size="small"
              />
            </InputAdornment>
          ),
        }}
        sx={{
          "& .MuiInputBase-root": {
            paddingRight: "3px",
            fontSize: "24px",
            borderRadius: "15px !important",
          },
        }}
      />
    </>
  );
};

export default AdditionalDiscount;
